/**
 * This module only returns false to disable any changes applied in debug.
 *
 * The debug module is used to apply changes to other modules only in the
 * development phase. It returns `true` to tell other module that we're in the
 * dev phase.
 *
 * This is the debug counterpart module. This module takes the place of
 * debug when required so debug is never bundled inside the prod build.
 */
define('debug',[
    'backbone',
], function(Backbone) {
    return false; // debug false
});

